<div class="row">
    <div class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div class="text-center">
            <div class="mb-3">
                <img src="/assets/logo.png" class="img">
            </div>
            <div class="d-flex flex-wrap pt-4 main">
                <div class="w-100 d-flex justify-content-center">
                    <a routerLink="/wppsi" class="btn wppsi">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center">
                                <div class="pe-3">
                                    <img src="/assets/wppsi.svg">
                                </div>
                                <div>
                                    WPPSI
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <i class="material-icons">
                                    chevron_right
                                </i>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="w-100 d-flex justify-content-center">
                    <a routerLink="/dccs" class="btn dccs">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center">
                                <div class="pe-3">
                                    <img src="/assets/dccs.svg">
                                </div>
                                <div>
                                    DCCS
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <i class="material-icons">
                                    chevron_right
                                </i>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="w-100 d-flex justify-content-center">
                    <a routerLink="/stroop" class="btn stroop">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center">
                                <div class="pe-3">
                                    <img src="/assets/stroop.svg">
                                </div>
                                <div>
                                    STROOP Test
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <i class="material-icons">
                                    chevron_right
                                </i>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="w-100 d-flex justify-content-center">
                    <a routerLink="/cantab" class="btn cantab">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center">
                                <div class="pe-3">
                                    <img src="/assets/cantab.svg">
                                </div>
                                <div>
                                    CANTAB Test
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <i class="material-icons">
                                    chevron_right
                                </i>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
